export default "__VITE_ASSET__CrFz9buO__"